module.exports = __webpack_public_path__ + "media/images/logo-light-ad11b65e1a1cd46406273037c73d6393.svg";